import {

  ArrowUpward,
  BarChart,
  CalendarMonth,
  CastForEducationOutlined,
  Details,
  FemaleOutlined,
  GirlOutlined,
  Group,
  GroupOutlined,
  Language,
  LocationCityOutlined,
  Lock,
  LockOutlined,
  Mail,
  MailOutline,
  Person,
  Person2Outlined,
  Person3Outlined,
  PersonOutline,
  Phone,
  PhoneOutlined,
  SchoolOutlined,
  PlaceOutlined,
  DetailsOutlined
} from "@mui/icons-material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import PeopleIcon from "@mui/icons-material/People";
import HeightIcon from "@mui/icons-material/Height";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import img1 from "../../Assets/stock_image5.avif";
import img2 from "../../Assets/userprofile/img2.png";
import mother from "../../Assets/userprofile/mother.jpg";
import father from "../../Assets/userprofile/father.png";
import match from "../../Assets/userprofile/match.png";
import connect from "../../Assets/userprofile/connection.png";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./UserProfile.css";
import EditIcon from "@mui/icons-material/Edit";
import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";
import ChatIcon from "@mui/icons-material/Chat";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import vagan from "../../Assets/userprofile/vagan.png";
import drink from "../../Assets/userprofile/drink.png";
import smoke from "../../Assets/userprofile/smoke.png";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HeartBrokenIcon from "@mui/icons-material/HeartBroken";
import Button from 'react-bootstrap/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import LoopIcon from "@mui/icons-material/Loop";

import StarBorderIcon from "@mui/icons-material/StarBorder";
// import PhoneIcon from "@mui/icons-material/Phone";
import crown from "./crown.png";
import SchoolIcon from "@mui/icons-material/School";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../BASE_URL";

import { OverlayTrigger, Popover } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { MdPlace } from "react-icons/md";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HomeIcon from '@mui/icons-material/Home';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GroupIcon from '@mui/icons-material/Group';
import MaleOutlinedIcon from '@mui/icons-material/MaleOutlined';
import { BiSolidBadgeCheck } from "react-icons/bi";

const loggedInUserId = localStorage.getItem("userId");

function MyVerticallyCenteredModal(props) {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const sliderRef = React.useRef(null);

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handleBack = () => {
    sliderRef.current.slickPrev();
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => setActiveSlideIndex(newIndex),
    arrows: false,
  };

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">All Photos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <div style={{ position: 'relative' }}>
              <Slider ref={sliderRef} {...sliderSettings}>
                {Array.isArray(props?.userPhotos) &&
                  props?.userPhotos.map((ele, index) => (
                    <div className="col-12 img-img" key={index}>
                      <img
                        className="w-100"
                        src={ele}
                        alt={`Image ${index + 1}`}
                        style={{ height: "500px", objectFit: "contain" }}
                      />
                    </div>
                  ))}
              </Slider>
              <div style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: 0 }}>
                <KeyboardArrowLeft onClick={handleBack} style={{ cursor: "pointer", fontSize: "60px" }} />
              </div>
              <div style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', right: 0 }}>
                <KeyboardArrowRight onClick={handleNext} style={{ cursor: "pointer", fontSize: "60px" }} />
              </div>
            </div>
            {/* Add photo counter here */}
            {Array.isArray(props?.userPhotos) && props?.userPhotos.length > 0 && (
              <p style={{ textAlign: 'center', marginTop: '10px', fontSize: '16px', color: '#555' }}>
                Photo {activeSlideIndex + 1} of {props.userPhotos.length}
              </p>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

const UserDetailById = () => {
  const [isBlockedByUser, setIsBlockedByUser] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Check if token is not available
    const token = localStorage.getItem("saptvidhiUserToken");
    if (!token) {
      // If token is not available, navigate to the home page
      navigate("/");
    }
  }, []);


  const location = useLocation();

  const stateData = location.state;
  // console.log(stateData)

  const [details, setDetails] = useState("");
  console.log(details);

  const { id } = useParams();
  const [family, setFamily] = useState("");
  const [familyValidation, setFamilyValidation] = useState([]);
  const [preference, setPreference] = useState("");
  const [religion, setReligion] = useState([]);
  const [language, setLanguage] = useState([]);
  const [contactDetail, setcontactDetail] = useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [otherDoc, setOtherDoc] = useState([]);
  const [otherSocial, setOtherSocial] = useState([]);
  const [otherInfo, setOtherInfo] = useState([]);

  const [otherFamily, setOtherFamily] = useState("");
  const [otherBirth, setOtherBirth] = useState("");
  const [hobbies, setHobbies] = useState([]);
  const [langaugeSpeak, setLangaugeSpeak] = useState([]);
  const [aassets, setAssets] = useState([])
  const [currentLocation, setCurrentLocation] = useState([]);
  const [buttonStatus, setButtonStatus] = useState("")
  console.log(details?.request_status)
  const[currentPhotoIndex, setCurrentPhotoIndex]=useState(0);

  const userDetails = async () => {
    try {
      const token = localStorage.getItem("saptvidhiUserToken");
      const res = await fetch(
        `${BASE_URL}/api/profile/userdetails?user_id=${id}`,
        {
          method: "GET",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await res.json();

      // Check if the current logged-in user is blocked by this profile
      if (data?.data?.UserDetails?.isBlocked &&
        data?.data?.UserDetails?.block_by === id) {
        setIsBlockedByUser(true);
        return;
      }

      setDetails(data?.data?.UserDetails);

      const userOtherInfos = data?.data?.UserDetails?.user_other_infos;
      if (userOtherInfos != null) {
        setOtherDoc(userOtherInfos.social_media);
        setOtherSocial(userOtherInfos.doc_verification);
        setOtherInfo(userOtherInfos);
        setAssets(userOtherInfos.assets);
        setCurrentLocation(userOtherInfos);
        setHobbies(userOtherInfos.hobbies_name);
        setLangaugeSpeak(userOtherInfos.languages_and_speak || []);
        setOtherBirth(userOtherInfos)
      }

      setcontactDetail(data?.data?.contact_info);
      setFamilyValidation(data?.data?.UserDetails?.family)
      if (data?.data?.UserDetails?.family?.length > 0) {
        setFamily(data?.data?.UserDetails?.family?.[0]);
      }
      setPreference(data?.data?.UserDetails?.preference?.[0]);
      setReligion(data?.data?.UserDetails?.preference?.[0]?.religion);
      setLanguage(data?.data?.UserDetails?.preference?.[0]?.language);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    if (details?.request_status === null && details?.action === null) {
      setButtonStatus("matches")
    } else if (details?.request_status == "pending" && details?.action == "sender") {
      setButtonStatus("sent")
    } else if (details?.request_status == "confirm") {
      setButtonStatus("accepted")
    } else if (details?.request_status == "cancel" && details?.action == "sender") {
      setButtonStatus("I cancel")
    } else if (details?.request_status == "cancel" && details?.action == "receiver") {
      setButtonStatus("They cancel")
    } else if (details?.request_status == "decline" && details?.action == "sender") {
      setButtonStatus("They decline")
    } else if (details?.request_status == "decline" && details?.action == "receiver") {
      setButtonStatus("I decline")
    } else if (details?.request_status === "pending" && details?.action === "receiver") {
      setButtonStatus("receive")
    } else {
      setButtonStatus("not matched")
    }
  }, [details]);


  // sent request or connect 
  const handlePendingConnect = async () => {

    try {
      const response = await fetch(`${BASE_URL}/api/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("saptvidhiUserToken"),
        },
        body: JSON.stringify({
          receiver_id: id,
          request_status: "pending",
          request_type: "request",
        }),
      });

      if (response.status == 200) {
        userDetails();
        toast.success('Request Send Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };

  // decline request 
  const handleInviteDecline = async (_id) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/request?_id=${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
          body: JSON.stringify({
            request_status: "decline",
            request_type: "request",
          }),
        }
      );
      if (response.status == 200) {
        userDetails();
        toast.success('Request decline Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };

  // reconnect 
  const handleResend = async (_id) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/request?_id=${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
          body: JSON.stringify({
            request_status: "pending",
            request_type: "request",
          }),
        }
      );
      if (response.status == 200) {
        userDetails();
        toast.success('Request Resend Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };

  //unsort 
  const handleShortlistDelete = async () => {
    try {
      await axios
        .delete(
          `${BASE_URL}/api/shortlist?shortlist_id=${id}`,
          {
            headers: { Authorization: localStorage.getItem("saptvidhiUserToken") },
          }
        )
        .then((res) => {
          if (res.data.code === 200) {
            toast.success('Removed From ShortList!', {
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 1000,
            });
            setTimeout(() => {
              navigate(-1)
            }, 1000);
          }
        })
        .catch((err) => alert(err));
    } catch (err) {
      alert(err);
    }
  };


  console.log(details)


  // shortlist 
  const handleShortlistAdd = async () => {
    try {
      console.log("Sending Request...");
      console.log("Shortlist ID:", id);
      console.log("Token:", localStorage.getItem("saptvidhiUserToken"));

      const response = await axios.post(
        `${BASE_URL}/api/shortlist`,
        { shortlist_id: id }, // OR use query params if required
        {
          headers: { Authorization: localStorage.getItem("saptvidhiUserToken") },
        }
      );

      console.log("Response:", response.data);

      if (response.data.code === 200) {
        toast.success("Added to Shortlist!", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      console.error("Error:", err);
      alert(err.response?.data?.message || "Something went wrong!");
    }
  };



  // Resend
  const handleConResend = async (userId) => {
    if (!userId) {
      toast.error('User ID not found');
      return;
    }

    try {
      const token = localStorage.getItem("saptvidhiUserToken");
      const response = await fetch(`${BASE_URL}/api/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          receiver_id: userId,
          request_status: "pending",
          request_type: "request",
        }),
      });

      const data = await response.json();

      if (response.status === 200) {
        userDetails(); // Refresh user details
        toast.success('Request Resent Successfully!', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });

        setTimeout(() => {
          navigate('/requests', {
            replace: true,
            state: {
              refresh: true,
              newRequest: {
                receiver_id: userId,
                status: "pending"
              }
            }
          });
        }, 1500);
      } else if (response.status === 403) {
        toast.error('Request Was Sent Previously!', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      } else {
        toast.error(data.message || 'Failed to send request', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error("Error sending request:", error);
      toast.error('Failed to resend request', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
    }
  };



  const member_type = localStorage.getItem("memberType");



  const [showModal1, setShowModal1] = useState(false);

  const openModal1 = () => {
    setShowModal1(true);
  };

  const closeModal1 = () => {
    setShowModal1(false);
  };


  const handleUnblock = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/api/blockuser?_id=${id}`,
        {
          headers: { Authorization: localStorage.getItem("saptvidhiUserToken") }
        }
      );

      if (response.data.code === 200) {
        // Update the local state to reflect the unblocked status
        setDetails(prev => ({
          ...prev,
          isBlocked: false,
          block_id: null
        }));

        closeUnblockModal();
        toast.success(`${details?.user_name} Unblocked Successfully`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to unblock user');
    }
  };

  const handleSentCancel = async (_id) => {
    console.log(_id)
    try {
      const response = await fetch(
        `${BASE_URL}/api/request?_id=${details?.request_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
          body: JSON.stringify({
            // receiver_id: data._id,
            request_status: "cancel",
            request_type: "request",
          }),
        }
      );
      if (response.status == 200) {
        userDetails();
        toast.success('Request Cancel Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };
  const handleDeclineCancel = async (_id) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/request?request_id=${_id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
        }
      );
      if (response.status == 200) {
        userDetails();
        toast.error('Request Deleted Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };

  const handleInviteAccept = async (_id) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/request?_id=${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
          body: JSON.stringify({
            // receiver_id: data._id,
            request_status: "confirm",
            request_type: "request",
          }),
        }
      );
      if (response.status == 200) {
        userDetails();
        toast.success('Request Accept Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };

  const handleAcceptDecline = async (_id) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/request?_id=${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("saptvidhiUserToken"),
          },
          body: JSON.stringify({
            // receiver_id: data._id,
            request_status: "decline",
            request_type: "request",
          }),
        }
      );
      if (response.status == 200) {
        userDetails();
        toast.error('Request decline Successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } catch (err) {
      alert(err);
    }
  };

  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
    handleClose111();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleBlock = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/blockuser`,
        { block_id: id },
        {
          headers: {
            Authorization: localStorage.getItem("saptvidhiUserToken"),
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.code === 200) {
        // Update the local state to reflect the blocked status
        setDetails(prev => ({
          ...prev,
          isBlocked: true,
          block_id: id // Add the block_id to the details
        }));

        toast.success('User blocked successfully', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
        closeModal();
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    } catch (err) {
      toast.error('Failed to block user');
      console.error(err);
    }
  };

  // const [showUnblockModal, setShowUnblockModal] = useState(false);

  const openUnblockModal = () => {
    setShowUnblockModal(true);
  };

  const closeUnblockModal = () => {
    setShowUnblockModal(false);
  };

  useEffect(() => {
    userDetails();
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const [seenContactDetails, setSeenContactDetails] = useState();
  const [showContactDetails, setShowContactDetails] = useState(false);
  const handleClickYes = async () => {
    try {
      const token = localStorage.getItem("saptvidhiUserToken");
      const response = await axios.post(
        `${BASE_URL}/api/count_of_contact_details`,
        { profile_id: id },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.code === 200) {
        setSeenContactDetails(response.data.data);
      } else {
        toast.error('your data limit is over', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }
    } catch (err) { }
  };

  const [Yay, setYay] = useState("");

  const Call = async () => {
    const token = localStorage.getItem("saptvidhiUserToken");
    const res = await fetch(`${BASE_URL}/api/profile/checkProfile`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    setYay(data?.data?.user[0]);
  };

  useEffect(() => {
    Call();
  }, []);

  const [showSecondModal, setShowSecondModal] = useState(false);


  const [show, setShow] = useState(false);
  const [showUnblockModal, setShowUnblockModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleUnblockClose = () => setShowUnblockModal(false);
  // const openUnblockModal = () => setShowUnblockModal(true);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => {
    setShowSecondModal(false);
  };

  const handleShow1 = async () => {
    setShow(false);

    setShowSecondModal(true);

    try {
      const token = localStorage.getItem("saptvidhiUserToken");
      const response = await axios.post(
        `${BASE_URL}/api/count_of_contact_details`,
        { profile_id: details?._id },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.code === 200) {
        setSeenContactDetails(response.data.data);
      } else {
        toast.error('Your date limit data over', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }
    } catch (err) {
    }
  };

  const handlePaidMember = () => {
    if (member_type === "paid") {
      setShow(true);
    } else (
      navigate("/selectplan")
    )
  }



  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose111 = () => {
    setAnchorEl(null);
  };

  const [profilePhoto, setProfilePhoto] = useState("");

  useEffect(() => {
    const storedProfilePhoto = localStorage.getItem("myprofilePhoto");

    try {
      const parsedProfilePhoto = JSON.parse(storedProfilePhoto);

      setProfilePhoto(parsedProfilePhoto);
    } catch (e) {
      setProfilePhoto(storedProfilePhoto);  // If it was stored as a string directly
    }
  }, []);


  // Add this helper function before the JSX
  const hasOtherDetails = () => {
    return (
      (hobbies && hobbies.length > 0) ||
      (aassets && aassets.length > 0) ||
      (langaugeSpeak && langaugeSpeak.length > 0) ||
      (otherInfo && otherInfo.settling_abroad) ||
      details?.settle_down
    );
  };

  // Add this helper function before the JSX
  const hasMatchPreferences = () => {
    return (
      (preference?.min_age || preference?.max_age) ||
      (preference?.min_height || preference?.max_height) ||
      (preference?.marital_status && preference?.marital_status.length > 0) ||
      (religion && religion.length > 0) ||
      (language && language.length > 0) ||
      preference?.country ||
      preference?.location ||
      preference?.annual_income ||
      (preference?.food_preferences && preference?.food_preferences.length > 0) ||
      (preference?.smoke && preference?.smoke.length > 0) ||
      (preference?.drink && preference?.drink.length > 0)
    );
  };

  return (
    <div className="container">
      {isBlockedByUser ? (
        <div
          className="text-center mt-5 p-4"
          style={{
            maxWidth: "600px",
            margin: "100px auto",
            background: "white",
            borderRadius: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
          }}
        >
          {/* <img 
            src="/blocked.png" 
            alt="Blocked" 
            style={{
              width: "100px",
              marginBottom: "20px"
            }}
          /> */}
          <h3 style={{ color: "#CF166F", marginBottom: "15px" }}>Access Denied</h3>
          <p style={{ fontSize: "16px", color: "#666" }}>
            You don't have access to view this profile as the user has blocked you.
          </p>
          <button
            onClick={() => navigate(-1)}
            style={{
              border: "none",
              padding: "10px 25px",
              borderRadius: "25px",
              color: "white",
              background: "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
              cursor: "pointer",
              marginTop: "15px"
            }}
          >
            Go Back
          </button>
        </div>
      ) : (
        <div className="userprofile">
          <div className="userprofile__left">
            <div className="userprofile_profile2">
              <div className="userprofile_profile_top2"
                style={{
                  position: "relative",
                  background: "linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)",
                  height: "45vh",
                  width: "100%",
                  borderRadius: "15px",
                  overflow: "hidden",
                  marginBottom: "25px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                }}>
                <img
                  src={Array.isArray(details?.user_photo)&& details.user_photo.length > 0 ? details.user_photo[currentPhotoIndex]: details?.profile_photo}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "top",
                    transition: "transform 0.3s ease",
                    display: "block",
                    cursor: "pointer"
                  }}
                  onClick={() => setModalShow(true)}
                />

                {details?.doc_verification && details.doc_verification.length > 0 && details.doc_verification[0].status === "approve" && (
                  <p className="crown_img2" style={{
                    position: "absolute",
                    top: "1%",
                    right: "5%",
                    fontSize: "32px",
                    color: "#E11D74",
                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))"
                  }} title="Verified User">
                    <BiSolidBadgeCheck />
                  </p>
                )}

                {details?.member_type === "paid" && (
                  // <img
                  //   src={crown}
                  //   className="crown_img"
                  //   alt=""
                  //   style={{
                  //     position: "absolute",
                  //     top: "5px",
                  //     right: "15px",
                  //     width: "35px",
                  //     height: "35px",
                  //     filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))"
                  //   }}
                  // />
                  <p className="crown_img" style={{
                    position: "absolute",
                    top: "8%",
                    right: "15px",
                    fontSize: "12px",
                    borderRadius: "20px",
                    padding: "5px 10px",
                    width: "fit-content",
                    height: "fit-content",
                    color: "white",
                    backgroundColor: "#CF166F",
                    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))"
                  }}>Premium</p>
                )}

                {/* Photo count overlay */}
                {Array.isArray(details?.user_photo) && details?.user_photo.length > 0 && (
                  <div style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "3px 8px",
                    borderRadius: "10px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    zIndex: 10
                  }}>
                    <KeyboardArrowLeft
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentPhotoIndex((prev) => (prev - 1 + details.user_photo.length) % details.user_photo.length);
                      }}
                      style={{ cursor: "pointer", fontSize: "18px", marginRight: "4px" }}
                    />
                    {currentPhotoIndex + 1}/{details.user_photo.length}
                    <KeyboardArrowRight
                      onClick={(e) => {
                        e.stopPropagation();
                        setCurrentPhotoIndex((prev) => (prev + 1) % details.user_photo.length);
                      }}
                      style={{ cursor: "pointer", fontSize: "18px", marginLeft: "4px" }}
                    />
                  </div>
                )}

              </div>
              <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                userPhotos={details?.user_photo}
              />

              <div className="userprofile_profile_bottom">
                <div className="userprofile_profile_bottom_detail_wrapper">
                  <PhoneOutlined />
                  {contactDetail?.contact_no}
                </div>
                <div className="userprofile_profile_bottom_detail_wrapper">
                  <MailOutline />
                  {contactDetail?.Email_id}
                </div>
                <div className="userprofile_profile_bottom_detail_wrapper">
                  <LockOutlined />
                  {details?.member_type} Member
                </div>
              </div>
            </div>
          </div>

          <div className="userprofile__right">
            <div className="sticky_div">
              <h2 title="User Name">{details?.user_name}</h2>
              <div>
                <div className="block_buton">
                  {details?.shortlisted ? (
                    // Show only Unshortlist and Block buttons when shortlisted is true
                    <>
                      <button onClick={handlePendingConnect}>
                        <FavoriteIcon sx={{ height: "20px", cursor: "pointer" }} />
                        Connect
                      </button>
                      <button onClick={() => handleShortlistDelete(details?.request_id)}>
                        <HeartBrokenIcon sx={{ height: "20px", cursor: "pointer" }} />
                        Unshortlist
                      </button>
                      <button className="block_confirm_button" onClick={openModal}>
                        <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                        Block
                      </button>
                    </>
                  ) : details?.isBlocked && details?.block_by === loggedInUserId ? (
                    // Show Unblock button when user is blocked
                    <button onClick={openUnblockModal} className="block_confirm_button">
                      <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                      Unblock
                    </button>
                  ) : (
                    // Show different buttons based on request status
                    <>
                      {details?.request_status === "pending" && details?.action === "sender" && (
                        <>
                          <button onClick={() => handleSentCancel(details?.request_id)} className="">
                            <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                            Cancel
                          </button>
                          {/* <button onClick={() => handleInviteDecline(details?.request_id)}>
                            <RemoveDoneIcon sx={{ height: "20px", cursor: "pointer" }} />
                            Decline1
                          </button> */}
                        </>
                      )}

                      {details?.request_status === "cancel" && details?.action === "receiver" && (
                        <>
                          {/* <button onClick={() => handleConResend(details?._id)}>
                            <LoopIcon sx={{ height: "25px", cursor: "pointer" }} />
                            Resend
                          </button> */}
                          {/* <button onClick={() => handleShortlistAdd(details?.request_id)}>
                            <StarBorderIcon sx={{ height: "25px", cursor: "pointer" }} />
                            Shortlist
                          </button> */}
                          <button className="block_confirm_button" onClick={openModal}>
                            <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                            Block
                          </button>
                        </>
                      )}
                      {details?.request_status === "cancel" && details?.action === "sender" && (
                        <>
                          <button onClick={() => handleResend(details?.request_id)}>
                            <LoopIcon sx={{ height: "10px", cursor: "pointer" }} />
                            Resend
                          </button>
                          {/* <button onClick={() => handleShortlistAdd(details?.request_id)}>
                            <StarBorderIcon sx={{ height: "25px", cursor: "pointer" }} />
                            Shortlist
                          </button> */}
                          <button className="block_confirm_button" onClick={openModal}>
                            <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                            Block
                          </button>
                        </>
                      )}

                      {details?.request_status === "pending" && details?.action === "receiver" && (
                        <>
                          <button onClick={() => handleInviteAccept(details?.request_id)}>
                            <DoneAllIcon sx={{ height: "18px", cursor: "pointer" }} />
                            Accept
                          </button>
                          <button onClick={() => handleInviteDecline(details?.request_id)}>
                            <RemoveDoneIcon sx={{ height: "18px", cursor: "pointer" }} />
                            Decline
                          </button>
                          <button className="block_confirm_button" onClick={openModal}>
                            <CancelOutlinedIcon sx={{ height: "18px", cursor: "pointer", marginRight: "3px" }} />
                            Block
                          </button>
                        </>
                      )}
                      {details?.request_status === "decline" && details?.action === "receiver" && (
                        <>
                          <button onClick={() => handleResend(details?.request_id)}>
                            <LoopIcon sx={{ height: "25px", cursor: "pointer" }} />
                            Resend
                          </button>
                          <button className="block_confirm_button" onClick={openModal}>
                            <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                            Block
                          </button>
                        </>
                      )}
                      {details?.request_status === "decline" && details?.action === "sender" && (
                        <>
                          {/* <button onClick={() => handleConResend(details?._id)}>
                            <LoopIcon sx={{ height: "25px", cursor: "pointer" }} />
                            Resend
                          </button> */}
                          <button className="block_confirm_button" onClick={openModal}>
                            <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                            Block
                          </button>
                        </>
                      )}
                      {details?.request_status === "confirm" && (
                        <>
                          {/* <button onClick={() => handleConResend(details?._id)}>
                            <LoopIcon sx={{ height: "25px", cursor: "pointer" }} />
                            Resend
                          </button> */}
                          <button onClick={() => handleInviteDecline(details?.request_id)}>
                            <RemoveDoneIcon sx={{ height: "20px", cursor: "pointer" }} />
                            Decline
                          </button>
                        </>
                      )}

                      {(!details?.request_status || details?.request_status === null) && (
                        <>
                          <button onClick={handlePendingConnect}>
                            <FavoriteIcon sx={{ height: "20px", cursor: "pointer" }} />
                            Connect
                          </button>
                          <button onClick={() => handleShortlistAdd(details?.request_id)}>
                            <StarBorderIcon sx={{ height: "20px", cursor: "pointer" }} />
                            Shortlist
                          </button>
                          <button className="block_confirm_button" onClick={openModal}>
                            <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                            Block
                          </button>
                        </>
                      )}

                      {/* Show chat button for connected users */}
                      {(details?.request_status === "confirm" ||
                        (details?.request_status === "pending" && (details?.action === "sender" || (details?.request_status === "confirm" && details?.action === "receiver")))) && (
                          <>
                            <button onClick={() => navigate("/messages", { state: { data: details } })}>
                              <ChatIcon sx={{ height: "20px", cursor: "pointer" }} />
                              Chat
                            </button>
                            {/* <button onClick={() => handleInviteDecline(details?.request_id)}>
                              <RemoveDoneIcon sx={{ height: "20px", cursor: "pointer" }} />
                              Decline2
                            </button> */}
                            {details?.request_status !== "block" && !details?.isBlocked && (
                              <button className="block_confirm_button" onClick={openModal}>
                                <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                                Block
                              </button>
                            )}
                          </>
                        )}

                      {/* Always show block button except for pending requests */}
                      {/* {details?.request_status !== "pending" && details?.request_status !== "block" && !details?.isBlocked && (
                        <button className="block_confirm_button" onClick={openModal}>
                          <CancelOutlinedIcon sx={{ height: "20px", cursor: "pointer", marginRight: "3px" }} />
                          Block
                        </button>
                      )} */}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="userprofile_intro">
              <div className="userprofile_intro_name">
                {/* <h2 title="User Name">{details?.user_name}</h2> */}
                <p className="userprofile_intro_height mb-0" title="age , height and weight">
                  <HeightIcon style={{ marginRight: "5px" }} />
                  {details?.age} yrs, {details?.height}, {details?.weight}kg
                </p>
                <div className="d-sm-flex d-block justify-content-between">
                  <div>
                    <p className="mb-sm-2 mb-1 " title="community and religion">
                      <PeopleIcon style={{ marginRight: "5px" }} />
                      {details?.community} , {details?.religion}
                    </p>
                  </div>
                  {otherInfo && otherInfo?.profile_manage?.length !== 0 ? (
                    <div className="profile-manage-container">
                      <p className="profile-manage-title">Profile Manage By:</p>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                        {otherInfo.profile_manage && otherInfo.profile_manage.map((item, index) => (
                          <span
                            key={index}
                            style={{
                              background: "#e0e0e0",
                              padding: "4px 12px",
                              borderRadius: "4px",
                              fontSize: "14px",
                              color: "#333"
                            }}
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : ""}
                </div>


                {/* asking for displaying contact detaisl  */}
                {/* // ... existing code ... */}

                {/* // Add this modal component near your other modals */}
                <Modal show={showModal} onHide={closeModal}>
                  <Modal.Body style={{ paddingTop: "40px", textAlign: "center", }}>
                    Are you sure you want to block this user?
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: "none", display: "flex", justifyContent: "center", width: "100%" }}>
                    <button
                      onClick={closeModal}
                      style={{
                        border: "none",
                        width: "90px",
                        padding: "7px 10px",
                        color: "white",
                        borderRadius: "10px",
                        background: "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)"
                      }}
                    >
                      No
                    </button>
                    <button
                      onClick={() => {
                        handleBlock();
                        closeModal();
                      }}
                      style={{
                        border: "none",
                        width: "90px",
                        padding: "7px 10px",
                        color: "white",
                        borderRadius: "10px",
                        background: "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)"
                      }}
                    >
                      Yes
                    </button>
                  </Modal.Footer>
                </Modal>

                {/* // ... rest of the code ... */}
                <Modal show={show} onHide={handleClose}>
                  <Modal.Body style={{ paddingTop: "40px" }}>Are you sure you want to see the contact of this user?</Modal.Body>
                  <Modal.Footer style={{ borderTop: "none", display: "flex", justifyContent: "center", width: "100%" }}>
                    <button variant="secondary" onClick={handleClose} style={{
                      border: "none",
                      width: "90px",
                      padding: "7px 10px",
                      color: "white",
                      borderRadius: "10px",
                      background: "linear-gradient(rgb(207, 22, 111) 0%, rgba(253, 7, 7, 0.5) 100%)"
                    }}>
                      No
                    </button>
                    <button variant="primary" onClick={handleShow1} style={{
                      border: "none",
                      width: "90px",
                      padding: "7px 10px",
                      color: "white",
                      borderRadius: "10px",
                      background: "linear-gradient(rgb(207, 22, 111) 0%, rgba(253, 7, 7, 0.5) 100%)"
                    }}>
                      Yes
                    </button>
                  </Modal.Footer>
                </Modal>

                {/* other user contact details  */}

                <Modal show={showSecondModal} onHide={handleClose1}>
                  <Modal.Body style={{ paddingTop: "40px" }} >
                    <div>
                      <div className="d-flex align-items-center justify-content-center">
                        <div >
                          <img src={details?.profile_photo} alt="" style={{ borderRadius: "50%", height: "60px", width: "60px", marginRight: "20px" }} />
                        </div>
                        <div>
                          <div className="modal-contact-info">
                            <div className="">
                              Phone number : {seenContactDetails?.[0]?.contact_no}
                            </div>
                            <div className="">
                              Email : {seenContactDetails?.[0]?.email}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal.Body>
                  <Modal.Footer style={{ borderTop: "none", display: "flex", justifyContent: "center", width: "100%" }}>
                    <button variant="primary" onClick={handleClose1} style={{
                      border: "none",
                      width: "90px",
                      padding: "7px 10px",
                      color: "white",
                      borderRadius: "10px",
                      background: "linear-gradient(rgb(207, 22, 111) 0%, rgba(253, 7, 7, 0.5) 100%)"
                    }}>
                      Close
                    </button>
                  </Modal.Footer>
                </Modal>





              </div>








              <div className="userprofile_intro_bio">
                <p style={{ 
                  fontSize: "21.5px", 
                  fontWeight: "600", 
                  textAlign: "left",
                  marginBottom: "10px",
                  marginTop: "0"
                }}>Bio</p>
                <p style={{ overflowWrap: "anywhere" }}>{details?.bio}</p>
              </div>
            </div>
            <div className="userprofile_basic_details">
              <div className="userprofile_section_header">
                <h3>Basic Details</h3>
              </div>
              <div className="userprofile_basic_details_content_wrapper row">
                <div className="userprofile_basic_details_content col-6 mb-2">
                  <FemaleOutlined />
                  <span title="Gender">{details?.gender}</span>
                </div>
                <div className="userprofile_basic_details_content col-6 mb-2">
                  <Language />
                  <span title="Mother Tongue">{details?.mother_tongue}</span>
                </div>
                <div className="userprofile_basic_details_content col-6 mb-2">
                  <CalendarMonth />
                  <span title="Date Of Birth">{details?.dob}
                    {otherBirth && otherBirth.birth_time && (
                      <>
                        <span>({otherBirth.birth_time})</span>
                      </>
                    )}
                  </span>
                </div>
                <div className="userprofile_basic_details_content col-6 mb-2">
                  <PersonOutline />
                  <span title="Religion">{details?.religion}</span>
                </div>

                {otherBirth && otherBirth.birth_place !== undefined && (
                  <div className="col-6 mb-2">
                    <div className="userprofile_basic_details_content">
                      {/* <MdPlace style={{ height: "30px", objectFit: "cover", width: "20px" }} /> */}
                      <img style={{ height: "21px", objectFit: "cover", width: "20px" }} src="/birthPlace.png" alt="" />

                      <p className="mb-0" title="Religion">
                        {/* <span style={{ fontWeight: "600" }}>Birth Place </span> */}
                        {otherBirth.birth_place}
                      </p>
                    </div>
                  </div>
                )}

                <div className="userprofile_basic_details_content col-6 mb-2">
                  <img
                    src="/weddingring.png"
                    style={{
                      height: "20px",
                      fontWeight: "600",
                      paddingRight: "5px",
                    }}
                  />
                  <span title="Marital Status">{details?.marital_status}</span>
                </div>

                <div className="userprofile_basic_details_content col-sm-6 col-12 mb-2">
                  <LocationCityOutlined />
                  <span title="City , State And Country">Lives in {details?.home_town}, {details?.state},{" "}
                    {details?.country}</span>
                </div>


                {currentLocation.current_location_country && (
                  <div className="col-6 mb-2">
                    <div className="userprofile_basic_details_content">
                      <PlaceOutlined />
                      <span className="mb-0" title="current city, state, country">
                        Current Location: {currentLocation.current_location_city},
                        {currentLocation.current_location_state},
                        {currentLocation.current_location_country}
                      </span>
                    </div>
                  </div>
                )}
                {/* hobbies  */}


                {hasOtherDetails() && (
                  <div style={{ marginBottom: "10px" }}>
                    <hr />
                    <h3 style={{ fontSize: "21.5px", fontWeight: "600", textAlign:"left" }}>Other Details</h3>

                    {hobbies && hobbies.length > 0 && (
                      <div className="mb-2" style={{ overflowWrap: "anywhere" }}>
                        <div className="userprofile_basic_details_content">
                          <div className="user-profile-by-id-hobbies-display">
                            <h6 className="mb-0">Hobbies :</h6>
                            <div>
                              {hobbies.map((e, index) => (
                                <p key={index} className="mb-sm-0 mb-1 label_for_p" title="Marital Status">
                                  {e}
                                </p>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {aassets && aassets.length > 0 && (
                      <div className="mb-2" style={{ overflowWrap: "anywhere" }}>
                        <div className="userprofile_basic_details_content">
                          <h6 className="mb-0 width_sm_hobby">Assets :</h6>
                          <div style={{ display: "flex", flexWrap: "wrap", rowGap: "8px" }}>
                            {aassets.map((e) => (
                              <p className="mb-0 label_for_p" title="Marital Status">{e}</p>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}

                    {langaugeSpeak.length > 0 ? (
                    <div className=" mb-2">
                      <div className="userprofile_basic_details_content">
                        <h6 className="mb-0">Langauge Speak :</h6>
                        {langaugeSpeak.map((e) => (
                          <p className="mb-0 label_for_p" title="Language Speaks" key={e}>
                            {e}
                          </p>
                        ))}
                      </div>
                    </div>
                  ) : null}

                  {otherInfo.settling_abroad && Object.keys(otherInfo).length > 0 && (
                    <div className="mb-2">
                      <div className="userprofile_basic_details_content">
                        <h6 title="Settling In Abbroad">Settling In Abroad? : </h6>
                        <p className="mb-0 label_for_p" title="Settling In Abroad">
                          {otherInfo.settling_abroad}
                        </p>
                      </div>
                    </div>
                  )}

                    {details?.settle_down && (
                      <div className="userprofile_basic_details_content" style={{ fontWeight: "500" }}>
                        Planning to settle-down : <span className="label_for_p" style={{ fontWeight: "400", textAlign:"left" }}>{details?.settle_down}</span>
                      </div>
                    )}
                  </div>
                )}
                    
                    {/* {otherInfo.settling_abroad && (
                      <div className="">
                        <div className="userprofile_basic_details_content">
                          <h6>Settling In Abroad? : {otherInfo.settling_abroad}</h6>
                        </div>
                      </div>
                    )}

                    {details?.settle_down && (
                      <div className="userprofile_basic_details_content" style={{ fontWeight: "500" }}>
                        Planning to settle-down : <span style={{ fontWeight: "400" }}>{details?.settle_down}</span>
                      </div>
                    )}
                  </div>
                )} */}

              </div>
            </div>

            {otherInfo?.length !== 0 ? (<>

              <div className="userprofile_family_details pb-4 ps-3 pt-3">
                <div className="userprofile_section_header">
                  <h3>Health Details</h3>
                </div>
                <div className="userprofile_family_details_content_wrapper ps-3">
                  {otherInfo && otherInfo?.blood_group !== "" && (
                    <div className="userprofile_family_details_content">
                      <div>
                        <span>Blood Group</span>
                        <p className="ms-2">{otherInfo && otherInfo.blood_group}</p>
                      </div>
                    </div>
                  )}
                  {otherInfo.any_disability !== "" && (
                    <div className="userprofile_family_details_content">
                      <div>
                        <span>Any Disability</span>
                        <p className="ms-2">{otherInfo && otherInfo?.any_disability}</p>
                      </div>
                    </div>
                  )}
                  {otherInfo.hiv !== "" && (
                    <div className="userprofile_family_details_content">
                      <div>
                        <span>Hiv</span>
                        <p className="ms-2">{otherInfo && otherInfo?.hiv}</p>
                      </div>
                    </div>
                  )}
                  {otherInfo.thalassemia !== "" && (
                    <div className="userprofile_family_details_content">
                      <div>
                        <span>Thalassemia</span>
                        <p className="ms-2">{otherInfo && otherInfo.thalassemia}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>) :

              ""}


            <div className="userprofile_basic_details">
              <div className="userprofile_section_header">
                <h3>Contact</h3>
              </div>
              <div className="userprofile_basic_details_content_wrapper2">
                <div className="userprofile_family_details_content">
                  <PhoneIcon />
                  <div>
                    <span>Phone</span>
                    <p>{contactDetail?.contact_no}</p>
                  </div>
                </div>
                <div className="userprofile_family_details_content">
                  <EmailIcon />
                  <div>
                    <span>Email</span>
                    <p>{contactDetail?.Email_id}</p>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="d-flex align-items-center flex-column">
                  <p>To unlock Contact No. & Email ID</p>
                  {member_type === "paid" ? (
                    <button
                      className="text-white"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      onClick={handlePaidMember} //added by Krish-Ansh 13-6-25, to remove double popup
                      style={{
                        border: "none",
                        padding: "10px 10px",
                        borderRadius: "40px",
                        background:
                          "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
                      }}
                    >
                      View Contact
                    </button>
                  ) : (
                    <button
                      className="text-white"
                      style={{
                        border: "none",
                        padding: "10px 10px",
                        borderRadius: "40px",
                        background:
                          "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
                      }}
                      onClick={() => navigate("/selectplan")}
                    >
                      Upgrade Plan
                    </button>
                  )}
                </div>
              </div>
            </div>
            {showContactDetails && (
              <div
                className="modal fade bd-example-modal-sm"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="mySmallModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-sm">
                  <div className="modal-content">
                    {seenContactDetails.contact_no}
                  </div>
                  <div className="modal-content">{seenContactDetails.email}</div>
                </div>
              </div>
            )}

            {/* Commented by Krish-Ansh 13-6-25, to remove double popup */}
            {/* {seenContactDetails ? (
              <div
                className={`modal fade ${isModalOpen ? "show" : ""}`}
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-content-photo">
                      <div>
                        <div>
                          <img src={details?.profile_photo} alt="" style={{ height: "50px", width: "50px", borderRadius: "50%" }} />
                        </div>
                      </div>
                      <div>
                        <div className="modal-contact-info">
                          <div className="">
                            Phone number : {seenContactDetails?.[0]?.contact_no}
                          </div>
                          <div className="">
                            Email : {seenContactDetails?.[0]?.email}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                      <button
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={handleModalClose}
                        style={{
                          border: "none",
                          width: "90px",
                          padding: "7px 10px",
                          color: "white",
                          borderRadius: "10px",
                          background: "linear-gradient(rgb(207, 22, 111) 0%, rgba(253, 7, 7, 0.5) 100%)"
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className={`modal fade ${isModalOpen ? "show" : ""}`}
                id="exampleModal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      Are you sure you want to see the contact of this user?
                    </div>
                    <div
                      className="modal-footer justify-content-center"
                      style={{ borderTop: "none" }}
                    >
                      <button
                        type="button"
                        className=""
                        data-dismiss="modal"
                        style={{
                          border: "none",
                          width: "90px",
                          padding: "7px 10px",
                          borderRadius: "10px",
                          color: "white",
                          background:
                            "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
                        }}
                        onClick={handleModalClose}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        className=" md-4"
                        onClick={handleClickYes}
                        style={{
                          border: "none",
                          width: "90px",
                          padding: "7px 10px",
                          borderRadius: "10px",
                          color: "white",
                          background:
                            "linear-gradient(180deg, #cf166f 0%, rgba(253, 7, 7, 0.5) 100%)",
                        }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )} */}




            <div className="userprofile_food_preference">
              <div className="userprofile_section_header">
                <h3>Food Preference</h3>
              </div>
              <div className="userprofile_food_preference_content_wrapper">
                <div className="userprofile_food_preference_content">
                  <img src={vagan} alt="" />
                  <p className="mb-0" title="Food Preference">{details?.food_preference}</p>
                </div>
                <div className="userprofile_food_preference_content">
                  <img src={drink} alt="" />
                  <p className="mb-0" title="Drink Preference">{details?.drink}</p>
                </div>
                <div className="userprofile_food_preference_content">
                  <img src={smoke} alt="" />
                  <p className="mb-0" title="Smoke Preference">{details?.smoke}</p>
                </div>
              </div>
            </div>
            <div className="userprofile_education">
              <div className="userprofile_section_header">
                <h3>Education & Career</h3>
              </div>
              <div className="userprofile_education_content_wrapper">
                <div className="userprofile_education_content">
                  <WorkOutlineIcon />
                  <p>
                    <span title="Highest Qualification">{details?.highest_qualification}</span> - <span title="College Name">{details?.college}</span>
                  </p>
                </div>
                <div className="userprofile_education_content">
                  <MilitaryTechIcon />
                  <p title="Company Name">{details?.company_name}</p>
                </div>
                <div className="userprofile_education_content">
                  <CalendarTodayIcon />
                  <p title="Job Title">{details?.job_title}</p>
                </div>
                {otherInfo?.employed_type?.[0] ? (
                  <div className="userprofile_education_content">
                    <CalendarTodayIcon />
                    <p title="Job Title">{otherInfo && otherInfo?.employed_type?.[0]}</p>
                  </div>
                ) : null}
                <div className="userprofile_education_content">
                  <BarChart />
                  <p title="Income Per Year">Earns INR {details?.salary} annually</p>
                </div>
              </div>
            </div>
            {familyValidation?.length > 0 && (
              <div className="userprofile_family_details ps-3">
                <div className="userprofile_section_header">
                  <h3>Family Details</h3>
                </div>
                <div className="userprofile_family_details_content_wrapper ps-3">
                  <div className="userprofile_family_details_content">
                    <AccountBalanceIcon />
                    <div>
                      <span>Mother's Occupation</span>
                      <p>{family?.mother_occupation}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <AccountBalanceIcon />
                    <div>
                      <span>Father's Occupation</span>
                      <p>{family?.father_occupation}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <GirlOutlined />
                    <div>
                      <span>Sister</span>
                      <p>{family?.no_of_sister}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <GirlOutlined />
                    <div>
                      <span>No Of Married Sister</span>
                      <p>{family?.no_of_married_sister}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <Person2Outlined />
                    <div>
                      <span>Brother</span>
                      <p>{family?.no_of_brother}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <Person2Outlined />
                    <div>
                      <span>No Of Married Brother</span>
                      <p>{family?.no_of_married_brother}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {otherInfo.family_income && (
              <div className="userprofile_family_details pb-4 ps-3 pt-3">
                <div className="userprofile_section_header">
                  <h3>Family Background</h3>
                </div>
                <div className="userprofile_family_details_content_wrapper ps-3">
                  <div className="userprofile_family_details_content">
                    <AccountBalanceIcon />
                    <div>
                      <span>Family Income</span>
                      <p>{otherInfo && otherInfo.family_income}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <HomeIcon />
                    <div>
                      <span>Family Status</span>
                      <p>{otherInfo && otherInfo?.family_status}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <FamilyRestroomIcon />
                    <div>
                      <span>Family Type</span>
                      <p>{otherInfo && otherInfo?.family_type}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <GroupIcon />
                    
                    <div>
                      <span>Family Values</span>
                      <p>{otherInfo && otherInfo.family_values}</p>
                    </div>
                  </div>
                  <div className="userprofile_family_details_content">
                    <EmojiPeopleIcon />
                    
                    <div>
                      <span>Living with Family?:</span>
                      <p>{otherInfo && otherInfo.living_with_parents}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {hasMatchPreferences() && (
              <div className="userprofile_matches">
                <div className="userprofile_matches_profile_images2">
                  <img
                    src={connect}
                    alt=""
                    className="userprofile_matches_connection"
                  />
                  <img src={profilePhoto} alt="" className="userprofile_matches_user" style={{ borderRadius: "100%" }} />
                  <div className="userprofile_matches_description2">
                  <span>You match 8/8 of his</span>
                  <p>Desired Preferences</p>
                  </div>
                  <img src={details?.profile_photo} alt="" className="userprofile_matches_user" style={{ borderRadius: "100%" }} />
                </div>
                
                <div className="userprofile_matches_content_wrapper">
                  <div className="left_pref">
                    <div className="userprofile_matches_content2">
                      <p>Age:</p>
                      <img src={match} alt="" />
                      <p>
                        {preference?.min_age || preference?.max_age ? (
                          <>
                            {preference?.min_age} to {preference?.max_age}
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>Height</p>
                      <img src={match} alt="" />
                      <p>
                        {preference?.min_height ? (
                          <>
                            {/* Display only feet/inches, remove cms */}
                            {preference?.min_height.split('(')[0]} to {preference?.max_height.split('(')[0]}
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                    <div
                      className="userprofile_matches_content2"
                      style={{ position: "relative" }}
                    >
                      <p>Marital Status</p>
                      <img src={match} alt="" />
                      <p>
                        <button
                          type="button"
                          className=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={preference?.marital_status?.join("\n")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            textAlign: "left",
                          }}
                        >
                          {preference?.marital_status?.slice(0, 2).map((e, index) => (
                            <span key={index} className="d-block">
                              {e}
                            </span>
                          ))}
                        </button>
                      </p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>Religion</p>
                      <img src={match} alt="" />
                      <p>
                        <button
                          type="button"
                          className=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={religion?.join("\n")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            textAlign: "left",
                          }}
                        >
                          {religion && religion?.slice(0, 2)?.map((e) => {
                            return (
                              <>
                                <span className="d-block">{e}</span>
                              </>
                            );
                          })}
                        </button>
                      </p>
                    </div>
                  </div>
                  <div className="mid_pref">
                    <div className="userprofile_matches_content2">
                      <p>Mother Tongue</p>
                      <img src={match} alt="" />
                      <p>
                        <button
                          type="button"
                          className=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={language?.join("\n")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            textAlign: "left",
                          }}
                        >
                          {language?.slice(0, 2)?.map((e) => {
                            return (
                              <>
                                <span className="d-block">{e} </span>
                              </>
                            );
                          })}
                        </button>
                      </p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>Country Living in</p>
                      <img src={match} alt="" />
                      <p>{preference?.country}</p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>State Living in</p>
                      <img src={match} alt="" />
                      <p>{preference?.location}</p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>Annual Income</p>
                      <img src={match} alt="" />
                      <p>{preference?.annual_income}</p>
                    </div>
                  </div>
                  <div className="right_pref">
                    <div className="userprofile_matches_content2">
                      <p>Diet</p>
                      <img src={match} alt="" />
                      <p>
                        <button
                          type="button"
                          className=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={preference?.food_preferences?.join("\n")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            textAlign: "left",
                          }}
                        >
                          {preference?.food_preferences?.slice(0, 2)?.map((e) => {
                            return (
                              <>
                                <span className="d-block">{e}</span>
                              </>
                            );
                          })}
                        </button>
                      </p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>Smoke</p>
                      <img src={match} alt="" />
                      <p>
                        <button
                          type="button"
                          className=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={preference?.smoke?.join("\n")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            textAlign: "left",
                          }}
                        >
                          {preference?.smoke?.slice(0, 2)?.map((e) => {
                            return (
                              <>
                                <span className="d-block">{e}</span>
                              </>
                            );
                          })}
                        </button>
                      </p>
                    </div>
                    <div className="userprofile_matches_content2">
                      <p>Drink</p>
                      <img src={match} alt="" />
                      <p>
                        <button
                          type="button"
                          className=""
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title={preference?.drink?.join("\n")}
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            textAlign: "left",
                          }}
                        >
                          {preference?.drink?.slice(0, 2)?.map((e) => {
                            return (
                              <>
                                <span className="d-block">{e}</span>
                              </>
                            );
                          })}
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <ToastContainer />
          </div>
        </div>
      )}
      {/* Add this modal for unblock confirmation */}
      <Modal show={showUnblockModal} onHide={closeUnblockModal}>
        <Modal.Body style={{ paddingTop: "40px", textAlign: "center", }}>
          Are you sure you want to unblock this user?
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none", display: "flex", justifyContent: "center", width: "100%" }}>
          <button
            onClick={closeUnblockModal}
            style={{
              border: "none",
              width: "90px",
              padding: "7px 10px",
              color: "white",
              borderRadius: "10px",
              background: "linear-gradient(rgb(207, 22, 111) 0%, rgba(253, 7, 7, 0.5) 100%)"
            }}
          >
            No
          </button>
          <button
            onClick={() => {
              handleUnblock(details?.block_id);
              closeUnblockModal();
            }}
            style={{
              border: "none",
              width: "90px",
              padding: "7px 10px",
              color: "white",
              borderRadius: "10px",
              background: "linear-gradient(rgb(207, 22, 111) 0%, rgba(253, 7, 7, 0.5) 100%)"
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>

  );
};

export default UserDetailById;